<template>
    <div class="c-row">
        <div class="c-tr">
            <div class="c-td is-1">
                <img
                    v-if="device.img"
                    width="20"
                    class="mr-3"
                    :src="require(`@/assets/img/drs/${device.img}`)"
                />
                {{ device.device_name }}
            </div>
            <div class="c-td is-2">
                <span v-text="'Nazwa'" class="typo-label" />
                {{ device.device_alias || '---' }}
            </div>
            <div class="c-td is-3">
                <span v-text="'Data dodania'" class="typo-label" />
                {{ $moment(device.created_at).format('DD-MM-YYYY') }}
            </div>
            <div class="c-td is-4">
                <span class="typo-label">
                    Status
                    <div
                        v-if="hasExpiredDocuments"
                        v-text="'!'"
                        v-tooltip="$options.expiredPaymentDevicesTooltip"
                        class="a-counter ml-2"
                    />
                </span>
                <span
                    v-if="status"
                    v-text="status.text"
                    class="status w-100"
                    :class="status.class"
                />
                <span v-else v-text="'---'" />
            </div>
            <div class="c-td is-5 typo--sm">
                <span v-text="'ID urządzenia'" class="typo-label" />
                {{ device.rad_id }}
            </div>
            <div class="c-td is-6">
                <the-btn
                    class="btn-outline-custom w-100"
                    text="Edytuj"
                    :disabled="!isActive"
                    @click="goToEdit"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { LICENSE_STATES, LICENSE_STATE_NAMES } from '@/utils/constants/drs/store-devices.js'
import { mapGetters } from 'vuex'

export default {
    expiredPaymentDevicesTooltip: 'Aby odblokować przesyłanie danych z urządzeń, należy opłacić subskrypcję.<br/>Możesz to zrobić w Ustawieniach płatności.',

    props: {
        device: { type: Object, required: true }
    },

    computed: {
        ...mapGetters('payment', ['hasExpiredDocuments']),

        status() {
            if (this.hasExpiredDocuments && this.isActive) {
                return {
                    text: LICENSE_STATES[this.device.state.code].text,
                    class: 'is-danger'
                }
            }
            return LICENSE_STATES[this.device.state.code]
        },

        isActive() {
            return this.device.state.code === LICENSE_STATE_NAMES.ACTIVE
        }
    },

    methods: {
        goToEdit() {
            this.$store.dispatch('openModal', {
                componentPath: 'drs/stores/licenses/LicenseForm',
                args: { license: this.device, mode: 'edit', status: this.status }
            })
        }
    }
}
</script>